<template>
  <Checkbox
  :id="'remember-login-checkbox'"
  :name="'remember-login-checkbox'"
  v-model="remember">
    Zapamiętaj mnie na tym komputerze
  </Checkbox>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue';

export default {
  name: 'RememberLoginCheckbox',
  components: {
    Checkbox
  },
  computed: {
    remember: {
      get() {
        return this.$store.getters.loginRemember;
      },
      set(value) {
        this.$store.commit('updateLoginRemember', value);
      }
    }
  }
};
</script>
